import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export type BlogCategoryTranslation = {
  _id?: string
  language: string
  title: string
  description?: string
}

export type BlogCategory = {
  _id?: string
  slug: string
  title: string
  description?: string
  status: 'active' | 'inactive'
  translations: BlogCategoryTranslation[]
}

export const getBlogCategories = async (page = 0, pageSize = 100) => {
  const response = await axios.get(`${API_URL}/blog-categories?page=${page}&size=${pageSize}`)
  return response.data
}

export const createBlogCategory = async (category: Omit<BlogCategory, '_id'>) => {
  const response = await axios.post(`${API_URL}/blog-categories`, category)
  return response.data
}

export const updateBlogCategory = async (id: string, category: Partial<BlogCategory>) => {
  const response = await axios.patch(`${API_URL}/blog-categories/${id}`, category)
  return response.data
}

export const deleteBlogCategory = async (id: string) => {
  await axios.delete(`${API_URL}/blog-categories/${id}`)
}
